import { useOutletContext } from "react-router-dom"

import type { Span } from "types/spans.types"

import { spanOverviewTabPlotDefs } from "helpers/config/dashboards"
import SpanDashboard from "widgets/spans/SpanDashboard"
import SpanAvailabilityNotice from "widgets/spans/SpanAvailabilityNotice"
import { BodyContainer } from "widgets/styled/containers"

const SpanOverview = () => {
  const { span } = useOutletContext<{ span: Span }>()

  const config = {
    type: "spanOverviewTab",
    plotDefs: spanOverviewTabPlotDefs,
  }

  return (
    <BodyContainer disableGutters maxWidth="xl">
      <SpanAvailabilityNotice span={span} />
      <SpanDashboard span={span} config={config} />
    </BodyContainer>
  )
}

export default SpanOverview
